"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const capabilities = [{
  label: "AI Threat Detection",
  href: "/AIThreatDetectionPage"
}, {
  label: "24/7 Security Monitoring",
  href: "/SecurityMonitoringPage"
}, {
  label: "Phishing Prevention",
  href: "/PhishingPreventionPage"
}, {
  label: "Vulnerability Assessments",
  href: "/VulnerabilityAssessmentsPage"
}, {
  label: "Incident Response",
  href: "/IncidentResponsePage"
}, {
  label: "Risk & Compliance",
  href: "/RiskCompliancePage"
}];
export default function Footer() {
  return <section data-section-id="4966" id="site-footer" className="relative bg-background text-foreground pt-[120px] pb-12 px-6 md:px-10 lg:px-16">
      {}
      <span aria-hidden="true" className="absolute top-4 left-4 w-4 h-4 border-l border-t border-border/60" />
      <span aria-hidden="true" className="absolute top-4 right-4 w-4 h-4 border-r border-t border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 left-4 w-4 h-4 border-l border-b border-border/60" />
      <span aria-hidden="true" className="absolute bottom-4 right-4 w-4 h-4 border-r border-b border-border/60" />

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {}
          <div className="lg:col-span-4 space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-[14px] text-muted-foreground font-default max-w-sm leading-relaxed">
              InfinitySecure delivers AI-powered cybersecurity solutions designed to protect businesses from modern cyber threats.
            </p>

            {}
            <div className="pt-4 space-y-1.5 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">HQ</span>
                <span className="text-foreground/80">Cannington, WA</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground/70">SEC</span>
                <span className="text-foreground/80">AI-DRIVEN</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-semibold">
              Navigate
            </h3>
            <MenuProvider menu_id="17">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-semibold">
              Capabilities
            </h3>
            <ul className="space-y-3">
              {capabilities.map((cap, i) => <li data-index={i} key={cap.label}>
                  <Link to={cap.href} className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                    {cap.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-semibold">
              Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/PrivacyPolicyPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/TermsConditionsPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/DisclaimerPage" className="text-foreground text-[15px] hover:text-primary transition-colors duration-200">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[12px] uppercase tracking-[0.15em] text-muted-foreground mb-6 font-semibold">
              Contact
            </h3>
            <div className="space-y-4">
              <p className="text-[14px] text-muted-foreground leading-relaxed font-default">
                37 Woodloes St,
                <br />
                Cannington WA 6107
              </p>
              <div className="space-y-2 font-mono text-[13px]">
                <Link to="mailto:info@infinitysecure.net" className="block text-foreground hover:text-primary transition-colors duration-200">
                  info@infinitysecure.net
                </Link>
                <Link to="tel:+61468086883" className="block text-foreground hover:text-primary transition-colors duration-200">
                  0468 086 883
                </Link>
              </div>
              <div className="pt-2 font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
                <span className="text-muted-foreground/70">WEB </span>
                <span className="text-foreground/80">infinitysecure.net</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative my-14">
          <div className="h-px bg-border w-full" />
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
            <span className="block w-3 h-px bg-border" />
            <span className="block w-px h-3 bg-border absolute" />
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center font-mono text-[11px] uppercase tracking-[0.12em]">
          {}
          <div className="text-muted-foreground text-center md:text-left">
            © 2026 InfinitySecure · All Rights Reserved
          </div>

          {}
          <div className="flex justify-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 border border-border text-foreground/80">
              <span className="text-muted-foreground/70">SEC/</span>
              <span>AI-PROTECTED</span>
            </span>
          </div>

          {}
          <div className="flex items-center gap-2 justify-center md:justify-end text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-lg bg-primary animate-pulse" aria-hidden="true" style={{
            boxShadow: "0 0 8px var(--primary)"
          }} />
            <span>
              System Status: <span className="text-foreground/80">Secure</span> ·
              Threats <span className="text-foreground/80">Neutralized</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}